const closeButtonLabel = "Chiudi";
const itIT = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  itIT as default
};
